import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/manage-reservation-tag';

const tagList = (merchantId, branchId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/${branchId}`, data);
};

const addTag = (merchantId, branchId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/${branchId}`, data);
};

const updateTag = (merchantId, branchId, id, data) => {
	return Client.put(`${baseUrl}/${merchantId}/${branchId}/${id}`, data);
};

export default {
	tagList,
	addTag,
	updateTag,
};
